<!-- <section class="breadcrumbs">
    <div class="container">

        <div class="d-flex justify-content-between align-items-center">
            <h2>Score Table </h2>
           
              <p-breadcrumb [model]="items"></p-breadcrumb>
            <ol>
                    <li [model]="items"><a href="index.html">Home</a></li>
                    <li>Products </li>
                </ol>
            
        </div>
    </div>
</section> -->
<!-- End Breadcrumbs -->
<!-- <div class="container-fluid p-0 about-fasinating-diamond-main-section">
    <div class="secure-shopping about-fasinating-diamond">
        <p-carousel [value]="bannerImageList" [numVisible]="1" [numScroll]="1" [circular]="true"
            [showIndicators]="false" [showNavigators]="false" [responsiveOptions]="carouselResponsiveOptions">
            <ng-template let-banner pTemplate="item">
                <div class="product-item">
                    <div class="product-item-content">
                        <div class="p-mb-1 banner-item-main">
                            <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
        <div class="container-fluid p-0">
            <div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;">
                <div class="section-title-text text-center pt-4">
                 
                   
                </div>
            </div>
            <div [innerHTML]="cmsContentData" class="section-contain"></div>
        </div>
    </div>
</div> -->

<main id="main">

    <!-- ======= About Us Section ======= -->

    <section class="about score-board">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="txt-advert animated fadeInUp">Season {{selectedTplSeason}} POINTs Table <Table></Table>
                    </h3>
                    <h6>TPL Score Board</h6>
                    <div class="dropdown">
                        <!-- <p-dropdown [options]="Seasons" [(ngModel)]="selectedCity" optionLabel="name"></p-dropdown> -->
                        <p-dropdown inputId="status" [options]="seasonpoint" [(ngModel)]="selectedSeasonPoint"
                            placeholder="Select" optionLabel="name" (onChange)="onSeasonpoint($event)"></p-dropdown>
                    </div>
                </div>
                <div class="col-md-12">
                    <img src="assets/img/point-table/table-cut/{{selectedTplscoreImg}}" alt="" style="width: 100%;">
                </div>
                <div class="col-md-12" *ngIf="selectedTplPlayerscoreImg">
                    <h3 class="txt-advert animated fadeInUp">TPL Player Standings
                    </h3>
                    <h6>Season {{selectedTplSeason}}</h6>
                </div>
                <!-- <div class="dropdown">
                    <p-dropdown [options]="Seasons" [(ngModel)]="selectedCity" optionLabel="name"></p-dropdown>
                </div> -->
                <div class="col-md-12 Standings" *ngIf="selectedTplPlayerscoreImg">
                    <img src="assets/img/point-table/table-cut/{{selectedTplPlayerscoreImg}}" alt=""
                        style="width: 100%;">
                </div>



            </div>

        </div>
    </section>
    <!-- ======= End About Us Section ======= -->


</main><!-- End #main -->